import React from 'react';

const ManageItems = () => {
    return (
        <div>

        </div>
    );
};

export default ManageItems;
